var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"currentColor"},React.createElement("path",{"d":"M14.9795143,9.35389838 L20.677131,15.2081489 C21.1075934,15.6500406 21.1075934,16.351269 20.6773083,16.7929787 L14.9838695,22.6428855 C14.7001148,22.9411144 14.2768452,23.0649271 13.8755774,22.9670774 C13.4743097,22.8692276 13.1569549,22.5648126 13.0446135,22.169995 C12.9322721,21.7751774 13.042277,21.350873 13.3283765,21.0633379 L18.25565,16.0006469 L13.3339117,10.9435791 C13.0045636,10.6146429 12.9087876,10.1203552 13.0917006,9.69355765 C13.2746094,9.26676982 13.6997166,8.99258424 14.1667754,9.0001528 C14.4772862,9.00516638 14.7725051,9.13487652 14.9795143,9.35389838 Z"})));
}

ChevronRight.defaultProps = {"className":"svg-chevron-right","viewBox":"0 0 32 32","stroke":"#000000","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
